import Phaser from 'phaser';
import dimensions from '../dimensions';
import Button from '../objects/ui/Button';

export default class PauseWindow extends Phaser.Group {
    constructor(game, parent) {
        super(game, parent);

        this.init();
    }

    init() {
        let background = this.game.add.graphics(0, 0);
        background.beginFill(0x000000, 1);
        background.drawRect(-dimensions.actualWidth / 2, (dimensions.actualHeight - dimensions.gameHeight) / 2 - dimensions.actualHeight / 2, dimensions.actualWidth, dimensions.actualHeight);
        background.alpha = 0.9;
        background.endFill();

        this.add(background);

        this.x = dimensions.gameWidth / 2;
        this.y = dimensions.gameHeight / 2;

        let bg = this.game.add.sprite(0, 25, "sheet", "ui-box");
        bg.anchor.set(0.5);
        this.add(bg);

        this.text = this.game.add.bitmapText(0, -60, "font-title", "Do you want to exit\nto\nmain menu?", 60);
        this.text.align = "center";
        this.text.anchor.set(0.5);
        this.add(this.text);

        this.yesButton = new Button(this.game, this, "mode-button", "Yes", 70, function () {}.bind(this));

        this.yesButton.x = -100;
        this.yesButton.y = 120;
        this.yesButton.scale.set(0.35, 0.5);
        this.yesButton.text.scale.set(0.5 / 0.35, 1);

        this.noButton = new Button(this.game, this, "mode-button", "No", 70, function () {}.bind(this));

        this.noButton.x = 100;
        this.noButton.y = 120;
        this.noButton.scale.set(0.35, 0.5);
        this.noButton.text.scale.set(0.5 / 0.35, 1);

        this.visible = false;
    }

    click() {
        if (this.alpha !== 1) return;

        let pos = this.game.gameState.offsetMouse();
        pos.x -= dimensions.gameWidth / 2;
        pos.y -= dimensions.gameHeight / 2;

        let yesX = pos.x - this.yesButton.x;
        let yesY = pos.y - this.yesButton.y;

        let noX = pos.x - this.noButton.x;
        let noY = pos.y - this.noButton.y;

        if (Math.abs(yesX) < this.yesButton.width / 2 && Math.abs(yesY) < this.yesButton.height / 2) this.yes();else if (Math.abs(noX) < this.noButton.width / 2 && Math.abs(noY) < this.noButton.height / 2) this.no();
    }

    yes() {
        this.game.paused = false;
        this.game.state.start('Menu');
    }

    no() {
        this.game.paused = false;
        this.hide();
    }

    show() {
        this.game.gameState.backButton.visible = false;
        this.visible = true;
        this.alpha = 0;
        this.game.add.tween(this).to({ alpha: 1 }, 200, Phaser.Easing.Linear.None, true).onComplete.add(function () {
            this.game.paused = true;
            this.game.input.onDown.add(this.click, this);
        }.bind(this));
    }

    hide() {
        this.game.input.onDown.removeAll();
        this.game.add.tween(this).to({ alpha: 0 }, 200, Phaser.Easing.Linear.None, true).onComplete.add(function () {
            this.visible = false;
            this.game.gameState.backButton.visible = true;
        }.bind(this));
    }
}


//////////////////
// WEBPACK FOOTER
// ./src/objects/PauseWindow.js
// module id = 143
// module chunks = 0